module.exports = __webpack_public_path__ + "img/EAC.d4504df1.jpg";